/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Chip_NoneInputs */

const vi_shop_home_chip_none = /** @type {(inputs: Shop_Home_Chip_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(kênh này không có khối)`)
};

/**

* @param {Shop_Home_Chip_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_chip_none = /** @type {((inputs?: Shop_Home_Chip_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Chip_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_chip_none(inputs)
});